import { render, staticRenderFns } from "./auto_market_official_module.vue?vue&type=template&id=af7bf97c&scoped=true"
import script from "./auto_market_official_module.vue?vue&type=script&lang=js"
export * from "./auto_market_official_module.vue?vue&type=script&lang=js"
import style0 from "./auto_market_official_module.vue?vue&type=style&index=0&id=af7bf97c&prod&lang=scss&scoped=true"
import style1 from "./auto_market_official_module.vue?vue&type=style&index=1&id=af7bf97c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7bf97c",
  null
  
)

export default component.exports